export const convertReal = (value, casa = 2) => {
    if (value === undefined || value == 'NaN' || value === null) {
        return '0,00';
    }
    else {
        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: casa,
            maximumFractionDigits: casa,
        })
    }
}